import React from 'react'

const DieStatusChange = () => {
  return (
    <div>DieStatusChange</div>
  )
}

export default DieStatusChange